var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.name,"label":_vm.label,"help-text":_vm.helpText,"error":_vm.error}},[_c('checkbox-widget',{attrs:{"name":_vm.name,"value":_vm.value,"options":_vm.options,"error":_vm.error,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }